import React from "react";
import { SubscriptionType } from "services/api/sessions/sessionService.types";
import { Spacer } from "styles/common/spacer";
import { PartyPopperIcon } from "../assets/party-popper";
import {
  FreeUserMobileUserNotice,
  FreeUserMobileUserNoticeMessage,
  FreeUserMobileUserNoticeMessageHeading1,
  FreeUserMobileUserNoticeMessageHeading2
} from "../free-user-landing/free-user-mobile.styles";
import { TrialActivationState } from "../trial-activation-modal/trial-activation-modal.types";
import { UserNoticeProps } from "./user-notice.types";

const UserNoticeMobile: React.FC<UserNoticeProps> = ({
  primaryUser,
  subscriptionStatus,
  activationState
}) => {
  const { subscriptionType, daysLeft } = subscriptionStatus;

  return (
    <FreeUserMobileUserNotice>
      <FreeUserMobileUserNoticeMessageHeading1>
        {activationState === TrialActivationState.TRIAL_ACTIVATED && (
          <>
            <PartyPopperIcon /> Hore!
          </>
        )}
        {subscriptionType === SubscriptionType.TRIAL &&
          activationState !== TrialActivationState.TRIAL_ACTIVATED &&
          `Hai, ${primaryUser.full_name}!`}
      </FreeUserMobileUserNoticeMessageHeading1>
      <Spacer token={[12, 12, 12]} />
      <FreeUserMobileUserNoticeMessageHeading2>
        {activationState === TrialActivationState.TRIAL_ACTIVATED &&
          "Coba gratis Kelas Live udah aktif 😉"}
        {subscriptionType === SubscriptionType.TRIAL &&
          activationState !== TrialActivationState.TRIAL_ACTIVATED &&
          `Coba gratis udah diaktifin, sisa ${daysLeft} hari lagi 😉`}
      </FreeUserMobileUserNoticeMessageHeading2>
      <Spacer token={[14, 14, 14]} />
      <FreeUserMobileUserNoticeMessage>
        {activationState === TrialActivationState.TRIAL_ACTIVATED &&
          "Cek jadwal dan masuk ke kelas yang bisa dicoba."}
        {subscriptionType === SubscriptionType.TRIAL &&
          activationState !== TrialActivationState.TRIAL_ACTIVATED &&
          "Coba gratis ini cuma ada sekali. Ikut kelasnya, ya!"}
      </FreeUserMobileUserNoticeMessage>
      <Spacer token={[4, 4, 4]} />
    </FreeUserMobileUserNotice>
  );
};

export { UserNoticeMobile };
